import { Component, Input, OnInit } from '@angular/core';
import { IndPhrase } from '@shared/models/cat.model';
import { AssociatedTextFinding, AssociatedTextPhrase } from '@shared/models/common';
import { NgRedux } from '@shared/redux/redux-compatibility.service';
import { AppState } from '@shared/redux/store';
import { getObjectPropValue } from '@shared/utils';

@Component({
    selector: 'cat-match-phrase-assoc-text',
    templateUrl: './cat-match-phrase-assoc-text.component.html',
    styleUrl: './cat-match-phrase-assoc-text.component.scss',
    standalone: false
})
export class CatMatchPhraseAssocTextComponent implements OnInit {
  @Input() associatedText?: AssociatedTextPhrase;
  @Input() mainPhrase: IndPhrase;
  @Input() associatedTextFinding?: AssociatedTextFinding;
  showOriginal: boolean = false;
  useCharBasedPhraseDiff = true;

  constructor(private ngRedux: NgRedux<AppState>) {}
  ngOnInit(): void {
    console.log("associated text: ", this.associatedText)
    console.log("main phrase: ", this.mainPhrase)
    console.log("assoc text finding: ", this.associatedTextFinding)
    const uiConfig = this.ngRedux.getState().uiConfig;

    this.useCharBasedPhraseDiff = getObjectPropValue(uiConfig, 'cat_match_phrase_display_settings.use_char_based_phrase_diff') ?? false;
    
  }

  catPhraseAssocText(catAssocPhraseId): AssociatedTextPhrase {
    return this.mainPhrase.associatedText.find(a => a.assocPhraseId === catAssocPhraseId);
  }

}
